import React, { useState } from 'react';
import CookieConsent from '@fuww/components/src/CookieConsent';
import { useIntl } from 'react-intl';
import messages from '../../lib/messages';
import cookieConsentTabs from './tabs';

const CookieConsentDialog = () => {
  const [open, setOpen] = useState(true);
  const [currentTab, setCurrentTab] = useState('general');

  const handleConsent = (granted) => {
    // eslint-disable-next-line unicorn/no-document-cookie
    document.cookie = `EU_COOKIE_LAW_CONSENT=${
      granted};path=/;max-age=31536000`;
    setOpen(false);
  };
  const intl = useIntl();

  return (
    <CookieConsent
      open={open}
      title={intl.formatMessage(messages['cookieConsent.title'])}
      tabs={cookieConsentTabs}
      currentTab={currentTab}
      onTabChange={setCurrentTab}
      message={(
        <div
          // eslint-disable-next-line react/no-danger
          dangerouslySetInnerHTML={{
            __html: intl.formatMessage(
              messages[`cookieConsent.${currentTab}.message`],
            ),
          }}
        />
      )}
      grantButtonText={intl.formatMessage(messages['cookieConsent.grant'])}
      denyButtonText={intl.formatMessage(messages['cookieConsent.deny'])}
      onGrant={() => handleConsent(true)}
      onDeny={() => handleConsent(false)}
    />
  );
};

export default CookieConsentDialog;
